import { SHOW_LOADER, REMOVE_LOADER } from "./actionTypes";

export const showLoader = () => ({
  type: SHOW_LOADER,
});

export const removeLoader = () => ({
  type: REMOVE_LOADER,
});
